// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-header-label {
  padding-right: 6px;
  font-size: 1.1rem;
  color: #888c94;
}

.case-header-text {
  padding-right: 12px;
  font-size: 1.1rem;
  color: #888c94;
}

.case-header-column {
  display: inline-block;
}

.header-actions-container {
  position: relative;
  right: 0;
  margin-left: auto;
}

.header-button {
  font-size: 16px;
  width: 32px;
  height: 28px;
  background-color: transparent;
  border-color: #adb5bd;
  color: #343a40;
  border-width: 1.5px;
  margin-top: -5px;
  margin-right: 10px;
}

.map-action {
  border-color: #199cb4;
  margin: -5px 0 0 0;
}

.map-action:hover {
  background-color: #199cb4 !important;
  border-color: #199cb4 !important;
  color: white !important;
}

.map-action:focus {
  background-color: #199cb4 !important;
  border-color: #199cb4 !important;
  color: white !important;
}

.selected {
  color: white;
  background-color: #199cb4;
  pointer-events: none;
}

.header-action-row {
  margin-top: 15px;
}
.header-action-row .header-action-wrapper {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/header/case-header.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,qBCLK;EDML,cC5BU;ED6BV,mBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,qBCvBK;EDwBL,kBAAA;AADF;;AAIA;EACE,oCAAA;EACA,gCAAA;EACA,uBAAA;AADF;;AAIA;EACE,oCAAA;EACA,gCAAA;EACA,uBAAA;AADF;;AAIA;EACE,YAAA;EACA,yBCzCK;ED0CL,oBAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,aAAA;EACA,yBAAA;AADJ","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n.case-header-label {\n  padding-right: 6px;\n  font-size: 1.1rem;\n  color: #888c94;\n}\n\n.case-header-text {\n  padding-right: 12px;\n  font-size: 1.1rem;\n  color: #888c94;\n}\n\n.case-header-column {\n  display: inline-block;\n}\n\n.header-actions-container {\n  position: relative;\n  right: 0;\n  margin-left: auto;\n}\n\n.header-button {\n  font-size: 16px;\n  width: 32px;\n  height: 28px;\n  background-color: transparent;\n  border-color: $gray;\n  color: $secondary;\n  border-width: 1.5px;\n  margin-top: -5px;\n  margin-right: 10px;\n}\n\n.map-action {\n  border-color: $info;\n  margin: -5px 0 0 0;\n}\n\n.map-action:hover {\n  background-color: $info !important;\n  border-color: $info !important;\n  color: white !important;\n}\n\n.map-action:focus {\n  background-color: $info !important;\n  border-color: $info !important;\n  color: white !important;\n}\n\n.selected {\n  color: white;\n  background-color: $info;\n  pointer-events: none;\n}\n\n.header-action-row {\n  margin-top: 15px;\n\n  .header-action-wrapper {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
